<div class="finalizare-container">
    <span class="finalizare-title">Finalizare Programare</span>

    <app-navbar-programare [onContinua]="handleFinalizare">
    </app-navbar-programare>

    <!-- SUMAR BENEFICIAR -->
    <div class="sumar-card">
        <div class="sumar-card__header">
            <div class="sumar-card__header-left">
                <mat-icon>person_outline</mat-icon>
                <span class="sumar-card__title">Sumar beneficiar</span>
            </div>
            <div class="d-flex flex-md-row flex-column gap-md-3 gap-2 align-items-center">
                <button *ngIf="detaliiState?.contractId" type="button" class="print-btn"
                    (click)="downloadFile(detaliiState!.contractId!)">
                    <mat-icon>print</mat-icon>
                    PRINT
                </button>
                <button type="button" class="draft-anulare-btn" (click)="handleAnulare()">
                    <mat-icon>delete_forever</mat-icon>
                    ANULEAZĂ CONTRACT
                </button>
            </div>
        </div>
        <div class="sumar-card__body" *ngIf="entitate">
            <div class="sumar-field">
                <span class="sumar-field__label">Nume și prenume</span>
                <span class="sumar-field__value">{{ entitate.full_name }}</span>
            </div>
            <div class="sumar-field">
                <span class="sumar-field__label">CNP</span>
                <span class="sumar-field__value">{{ entitate.cnp }}</span>
            </div>
            <div class="sumar-field" *ngIf="entitate.tutore_relationships.length > 0">
                <span class="sumar-field__label">Tutore</span>
                <span class="sumar-field__value">{{ entitate.tutore_relationships[0].related_entity_name }}</span>
            </div>
            <div class="sumar-field" *ngIf="entitate.current_address">
                <span class="sumar-field__label">Adresă</span>
                <span class="sumar-field__value">{{ entitate.current_address.formatted_address }}</span>
            </div>
            <div class="sumar-field" *ngIf="detaliiState?.selectedStartDate && detaliiState?.selectedEndDate">
                <span class="sumar-field__label">Perioadă contractuală</span>
                <span class="sumar-field__value">
                    {{ detaliiState!.selectedStartDate | date:'dd.MM.yyyy' }} -
                    {{ detaliiState!.selectedEndDate | date:'dd.MM.yyyy' }}
                </span>
            </div>
        </div>
    </div>

    <!-- TITLU SECTIUNE PROGRAMARI -->
    <div class="sectiune-header">
        <span class="sectiune-header__title">Programări contractuale</span>
        <span class="sectiune-header__count">{{ subcontracteLocale.length }} programări</span>
    </div>

    <!-- EMPTY STATE -->
    <div class="empty-state" *ngIf="subcontracteLocale.length === 0">
        <mat-icon>event_busy</mat-icon>
        <span>Nu există programări contractuale configurate.</span>
    </div>

    <!-- LISTA SUBCONTRACTE -->
    <div class="subcontracte-grid" *ngIf="subcontracteLocale.length > 0">
        <div class="sub-card" *ngFor="let sub of subcontracteLocale">

            <div class="sub-card__header">
                <div class="sub-card__header-left">
                    <mat-icon>medical_services</mat-icon>
                    <span class="sub-card__specializare">{{ sub.specializare_name }}</span>
                </div>
                <div class="sub-card__actions">
                    <button type="button" class="sc-action-btn sc-action-btn--edit" (click)="onEditSubcontract(sub)"
                        matTooltip="Editează">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button type="button" class="sc-action-btn sc-action-btn--delete" (click)="onDeleteSubcontract(sub)"
                        matTooltip="Șterge">
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                </div>
            </div>

            <div class="sub-card__meta">
                <div class="sub-meta-row">
                    <span class="sub-meta-label">Interval ședințe:</span>
                    <span class="sub-meta-value">
                        {{ sub.date_from_sedinte | date:'dd.MM.yyyy' }} –
                        {{ sub.date_end_sedinte | date:'dd.MM.yyyy' }}
                    </span>
                </div>
                <div class="sub-meta-row">
                    <span class="sub-meta-label">Nr. ședințe:</span>
                    <span class="sub-meta-value">{{ sub.nr_sedinte }}</span>
                </div>
                <div class="sub-meta-row">
                    <span class="sub-meta-label">Frecvență:</span>
                    <span class="sub-meta-value">{{ sub.frecventa_sedinte }} / săptămână</span>
                </div>
            </div>

            <div class="sub-card__specialisti">
                <ng-container *ngFor="let spec of getSpecialistiDinSubcontract(sub)">
                    <div class="spec-block">
                        <div class="spec-block__header">
                            <mat-icon>person_outline</mat-icon>
                            <span class="spec-block__name">{{ spec.nume }}</span>
                        </div>
                        <div class="spec-block__chips">
                            <div class="prog-chip" *ngFor="let slot of spec.slots">
                                <span class="prog-chip__dow">{{ getDayOfWeekRo(slot.date) }}</span>
                                <span class="prog-chip__date">{{ slot.date | date:'dd.MM.yyyy' }}</span>
                                <span class="prog-chip__time">{{ formatSlotTime(slot) }}</span>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>

        </div>
    </div>

    <!-- DOCUMENTE ATAȘATE -->
    <!-- Vizibil doar când există un contract (nou sau din draft) -->
    <ng-container *ngIf="currentContract">
        <div style="background-color: #ffffff;">
            <app-documente [contract]="currentContract" (contractChanged)="onContractChanged()">
            </app-documente>
        </div>
    </ng-container>

</div>

<!-- SPINNER LOADING -->
<div class="section-spinner position-absolute" *ngIf="isLoading">
    <div class="spinner position-absolute top-50 start-50 translate-middle">
        <mat-spinner></mat-spinner>
        <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
    </div>
</div>